import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface TooltipProps {
  content: ReactNode
  children: ReactNode
  side?: 'top' | 'bottom'
  align?: 'center' | 'start' | 'end'
  className?: string
}

// Tooltip CSS-only (sem portal/deps). Estilo dark discreto à la Linear/Stripe.
// Ideal pra explicar métricas em cards e headers. Evite usar dentro de
// containers com overflow:hidden (tabelas com scroll) — ali pode ser cortado.
export function Tooltip({ content, children, side = 'top', align = 'center', className }: TooltipProps) {
  return (
    <span className="group/tt relative inline-flex">
      {children}
      <span
        role="tooltip"
        className={cn(
          'pointer-events-none absolute z-50 w-max max-w-[16rem] whitespace-normal',
          'rounded-md bg-fg-1 px-2.5 py-1.5 text-left text-2xs font-medium leading-relaxed text-bg-surface shadow-md',
          'opacity-0 transition-all duration-150 ease-out',
          'group-hover/tt:opacity-100',
          side === 'top'
            ? 'bottom-full mb-1.5 translate-y-1 group-hover/tt:translate-y-0'
            : 'top-full mt-1.5 -translate-y-1 group-hover/tt:translate-y-0',
          align === 'center' && 'left-1/2 -translate-x-1/2 group-hover/tt:-translate-x-1/2',
          align === 'start' && 'left-0',
          align === 'end' && 'right-0',
          className,
        )}
      >
        {content}
      </span>
    </span>
  )
}
